/**
 * PUT файла в S3 по presigned URL через XHR — ради прогресса загрузки
 * (fetch не сообщает прогресс отправки). Bearer не шлём: подпись в URL.
 */
export function putWithProgress(
  url: string,
  file: Blob,
  contentType: string,
  onProgress?: (fraction: number) => void,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);
    xhr.setRequestHeader('Content-Type', contentType);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress?.(e.loaded / e.total);
    };
    xhr.onload = () =>
      xhr.status >= 200 && xhr.status < 300
        ? resolve()
        : reject(new Error(`Загрузка в хранилище не удалась (${xhr.status})`));
    // CORS-отказ хранилища браузер тоже отдаёт как сетевую ошибку.
    xhr.onerror = () =>
      reject(new Error('Загрузка в хранилище не удалась: нет связи с хранилищем или запрет CORS'));
    xhr.send(file);
  });
}
